import { createSlice } from "@reduxjs/toolkit"
import { getTaxDetails, updateTaxDetails } from "store/actions/taxAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 12,
  taxDetails: {},
}

const usersSlice = createSlice({
  name: "tax",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET TAX DETAILS
    builder
      .addCase(getTaxDetails.pending, state => {
        state.loading = true
      })
      .addCase(getTaxDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.taxDetails = data
          // console.log(data)
        }
      })
      .addCase(updateTaxDetails.rejected, (state, action) => {
        state.isLoading = false
      })

      //   UPDATE ITEM
      .addCase(updateTaxDetails.pending, state => {
        state.isLoading = true
      })
      .addCase(updateTaxDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
        }
      })
      .addCase(getTaxDetails.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
